import { ProductBlock } from "./product-block";
import Blocks from "../blocks";


export class ThreeColumnFlyInBlock extends ProductBlock {
    public static CLASS_NAME = "three-column-fly-in-block";

    private blockTitle: JQuery;
    private blockImage: JQuery;
    private stickObjects: JQuery[];

    private bodyPadding: number;
    private stickPos: number;
    private lastRowOffset: number;
    private initiated: boolean;
    private stickPositionSet: boolean;

    constructor(e: HTMLElement) {
        super(e);

        this.blockTitle = $(".block-title", this.element);
        this.blockImage = $(".block-image", this.element);
        this.stickObjects = $(".stick-object", this.element).map((i, e) => { return $(e); }).toArray();
    }

    public initiate() {
        if (this.initiated) {
            this.initiated = false;
            // Reinitiate after window resize
            this.stickObjects.forEach(e => {
                this.resetObject(e);
            });

            this.stickObjects = $(".stick-object", this.element).map((i, e) => { return $(e); }).toArray();
        }

        super.initiate();

        if (!ProductBlock.isMobile() && this.fitsInWindow()) {
            setTimeout(() => {
                this.bodyPadding = parseInt($("body").css("paddingTop"));
                this.bodyPadding += parseInt($(".main-wrapper").css("marginTop"));

                let lastRow = $('.row:last-child', this.element);
                this.lastRowOffset = lastRow.offset().top;

                let titleFixedPos = this.initBlockTitle();
                let imageWindowEndPos = this.initBlockImage(titleFixedPos);

                this.stickObjects.forEach(e => {
                    this.initStickObject(e, imageWindowEndPos);
                });

                let lastStickObject = this.stickObjects[this.stickObjects.length - 1];
                this.stickPos = lastStickObject.data("fixed-pos");

                this.stickObjects.push(this.blockImage);
                this.stickObjects.push(this.blockTitle);

                this.initiated = true;
                this.onScroll();
            }, 500);
        }
        else {
            this.element.addClass("normalize");
        }
    }

    private fitsInWindow(): boolean {
        let titleHeight = this.blockTitle.length ?
            this.blockTitle.height() + parseInt(this.blockTitle.css("marginBottom")) : 0;

        let imageHeight = this.blockImage.height() ?
            this.blockImage.height() + parseInt(this.blockImage.css("marginBottom")) : 0;

        let blockPadding = parseInt(this.element.css("paddingTop")) + parseInt(this.element.css("paddingBottom"));
        let columnMaxHeight = 0;
        this.stickObjects.forEach(e => {
            columnMaxHeight = Math.max(columnMaxHeight, e.height());
        });

        let totalHeight = titleHeight + imageHeight + columnMaxHeight + blockPadding;
        return $(window).height() > totalHeight;
    }

    private resetObject(stickObject: JQuery) {
        // Remove style if reinit after window resize
        stickObject.removeClass("fixed");
        stickObject.removeClass("stick");
        stickObject.css("top", "");
        stickObject.css("margin-left", "");
        stickObject.css("transform", "");

        stickObject.css("width", "");
        stickObject.css("height", "");

        const objectParent = $(stickObject.parent());
        objectParent.css("height", "");
    }

    private initStickObject(stickObject: JQuery, offsetDiff: number) {
        const objectParent = $(stickObject.parent());

        let fixedPos = stickObject.offset().top - offsetDiff;

        stickObject.data("fixed-pos", fixedPos);
        stickObject.data("fixed-offset", offsetDiff);

        // Set height to keep initial height when child is fixed positioned

        objectParent.height(objectParent.height());

        stickObject.width(stickObject.width());
        stickObject.height(stickObject.height());
        stickObject.data("left-offset", stickObject.offset().left - objectParent.offset().left);

        const objectMargin = parseInt(stickObject.css("marginBottom"));
        let objectStickOffset = this.lastRowOffset - stickObject.offset().top - objectMargin;
        stickObject.data("fixed-pos", fixedPos);
        stickObject.data("stick-offset", objectStickOffset);
    }

    private initBlockImage(titleFixedPos: number): number {
        const objectParent = $(this.blockImage.parent());

        // Set height to keep initial height when child is fixed positioned
        objectParent.height(objectParent.height());

        const titleMargin = parseInt(this.blockTitle.css("marginBottom"));
        let fixedPos = titleFixedPos;
        let offsetDiff = this.blockImage.offset().top - fixedPos;
        this.blockImage.data("fixed-pos", fixedPos);
        this.blockImage.data("fixed-offset", offsetDiff);
        this.blockImage.data("left-offset", this.blockImage.offset().left - this.blockImage.parent().offset().left);
        this.blockImage.width(this.blockImage.width());
        this.blockImage.height(this.blockImage.height());
        const imageMargin = parseInt(this.blockImage.css("marginBottom"));

        //const objectMargin = parseInt(this.blockImage.css("marginBottom"));
        let objectStickOffset = this.lastRowOffset - this.blockImage.offset().top - this.blockImage.height() + titleMargin - this.bodyPadding + imageMargin + 4;
        this.blockImage.data("fixed-pos", fixedPos);
        this.blockImage.data("stick-offset", objectStickOffset);

        return offsetDiff + this.blockImage.height() + imageMargin + titleMargin;
    }

    private initBlockTitle(): number {
        const objectParent = $(this.blockTitle.parent());

        // Set height to keep initial height when child is fixed positioned
        objectParent.height(objectParent.height());
        let fixedPos = this.element.offset().top - this.bodyPadding;
        let offsetDiff = this.blockTitle.offset().top - this.element.offset().top + this.bodyPadding;
        this.blockTitle.attr("data-fixed-offset", offsetDiff);
        this.blockTitle.attr("data-fixed-pos", fixedPos);

        const objectMargin = parseInt(this.blockTitle.css("marginBottom"));
        let objectStickOffset = this.lastRowOffset - this.blockTitle.offset().top - this.blockImage.height() - this.bodyPadding * 2 - 20;
        this.blockTitle.attr("data-fixed-pos", fixedPos);
        this.blockTitle.attr("data-stick-offset", objectStickOffset);

        return fixedPos;
    }

    protected onScroll() {
        super.onScroll();

        if (this.initiated && this.isInView) {
            const currScrollPos = window.pageYOffset;
            const diff = currScrollPos - this.inViewPos;

            this.stickObjects.forEach((e, i) => {
                const stickObject = e;
                const objectFixedPos = stickObject.data("fixed-pos");

                if (currScrollPos >= this.stickPos && currScrollPos <= this.outOfViewPos) {
                    this.setStickPosition(e);
                    stickObject.removeClass("fixed");
                    stickObject.css("top", stickObject.data("stick-offset"));
                    stickObject.css("margin-left", "");
                    stickObject.css("transform", "");
                }
                else if (currScrollPos >= objectFixedPos && currScrollPos <= this.outOfViewPos) {
                    const fixedOffset = stickObject.data("fixed-offset");

                    stickObject.addClass("fixed");
                    stickObject.removeClass("stick");
                    stickObject.css("top", `${fixedOffset}px`);
                    stickObject.css("margin-left", stickObject.data("left-offset"));
                }
                else {
                    stickObject.removeClass("fixed");
                    stickObject.removeClass("stick");
                    stickObject.css("top", "");
                    stickObject.css("margin-left", "");
                    stickObject.css("transform", "");
                }
            });
        }
        else if (this.initiated && !this.stickPositionSet && window.scrollY > this.outOfViewPos) {
            this.stickPositionSet = true;

            this.stickObjects.forEach((e, i) => {
                this.setStickPosition(e);
            });
        }
    }

    private setStickPosition(stickObject: JQuery) {
        stickObject.addClass("stick");
        stickObject.removeClass("fixed");
        stickObject.css("top", stickObject.data("stick-offset"));
        stickObject.css("margin-left", "");
        stickObject.css("transform", "");
    }

    protected inView() {
        super.inView();
        this.stickPositionSet = false;
    }

    protected outOfView() {
        super.outOfView();
    }

    protected activate() {
        super.activate();
    }
}